import React, { useContext } from 'react'
import { getLanguageLocale, getMarket } from 'shared/index'
import { FormBuilder } from '@tf/formbuilder'
import { FormWrapper } from 'shared/formBuilder/formWrapper'
import { AccountAddressFormDE_AT } from 'shared/formBuilder/forms/customerInformationFormDE_AT'
import { useTranslation } from 'react-i18next'
import SspContext from 'selfServicePortal/contexts/SspContext'
import { Heading } from 'selfServicePortal/components'
import { ICustomer } from 'selfServicePortal/interfaces/i-api-customer'

function deriveAddressForm(formMeta: any, data: any) {
	return FormWrapper([AccountAddressFormDE_AT(data)], formMeta)
}

interface AddressFormProps {
	onSuccess: (customer: ICustomer) => void
}

export function AddressForm({ onSuccess }: AddressFormProps) {
	const { t } = useTranslation()
	const { customerData } = useContext(SspContext)
	const adressFormSchema = deriveAddressForm(
		{
			formName: 'address',
			blockName: 'address',
			market: getMarket(),
			locale: getLanguageLocale(),
			getDataUrl: '',
			validationErrorList: false,
			requiredMessage: t('ValidateRequired'),
			submitButtonText: t('AddressChangeButton'),
		},
		customerData,
	)

	return (
		<>
			<Heading
				title={t('AddressChangeTitle')}
				description={t('AddressChangeDescription')}
			/>

			<FormBuilder
				formSchema={adressFormSchema}
				apiError={undefined}
				showErrorsInForm={true}
				showSubmitButton={true}
				onSubmit={({ customer }) => onSuccess(customer)}
			/>
		</>
	)
}
